import styles from './IdBadge.module.scss'; 

type Props ={
    id: number | string
}

export const IdBadge = ({ id }:Props) => {
  return (
    <div className={styles.idBadge}>
      <span className={styles.idText}>ID: {id}</span>
    </div>
  );
};
